export const Footer = () => (
  <div className="so-back LaboratoryChrome__terms" data-testid="page-footer">
    <div className="so-chunk ">
      Action.fan
    </div>
  </div>
);
